export default __webpack_public_path__ + "static/pakistan-results-1-66a0064220ff95ec4741192d73a7f453.png";